import Loading from "@/components/Loading/Loading"

import { useEnrolledCoursesData } from "@/queries/queries"
import moment from "moment"
import { useTranslation } from "react-i18next"
import RoundLatestLecture from "./RoundLatestLecture"

export default function LatestLectures() {
  const { t } = useTranslation()

  const enrolledCoursesQuery = useEnrolledCoursesData()

  if (enrolledCoursesQuery.isLoading) {
    return <Loading />
  }

  if (!enrolledCoursesQuery.data?.data?.length) {
    return null
  }

  const latestLectures = enrolledCoursesQuery.data?.data?.filter((round) => {
    const latestLecture = round?.lectures?.[0]
    if (!latestLecture) return false

    return (
      moment(latestLecture?.start_time).isSame(new Date(), "day") &&
      round.type === 1 // online rounds only
    )
  })

  if (!latestLectures?.length) return null

  return (
    <div className="home-section-card">
      <h5 className="section-title">{t("homePage.latestLectures.title")}</h5>
      <div className="d-flex flex-column gap-3">
        {latestLectures?.map((round) => {
          return <RoundLatestLecture key={round.id} round={round} />
        })}
      </div>
    </div>
  )
}
